import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function RequirePerm({ perm, children }) {
  const { can } = useAuth();
  return can(perm) ? children : <Navigate to="/office" replace />;
}
